export enum COPAY_PERMISSION {
  COPAY_PROCEDURE_ADD_DESCRIPTION = 'copay_procedure:add_description',
  COPAY_PROCEDURE_ADD_LABEL = 'copay_procedure:add_label',
  COPAY_PROCEDURE_UPDATE_DESCRIPTION = 'copay_procedure:update_description',
  COPAY_PROCEDURE_UPDATE_LABEL = 'copay_procedure:update_label',
}

export enum COMPANY_PERMISSION {
  COMPANY_USER_UNBLOCK = 'company_user:unblock',
  COMPANY_USER_CREATE = 'company_user:create',
  COMPANY_USER_DELETE = 'company_user:delete',
  COMPANY_USER_READ = 'company_user:read',
  COMPANY_USER_RESTORE = 'company_user:restore',
  COMPANY_USER_UPDATE = 'company_user:update',
  MOVE_CREATE = 'movimentation:create',
  BENEFICIARY_EXPORT = 'beneficiary:export',
  CUSTOMIZIATIONS_APP = 'customizations:app',
}

export enum BROKER_PERMISSION {
  BROKER_USER_UNBLOCK = 'broker_user:unblock',
  BROKER_USER_CREATE = 'broker_user:create',
  BROKER_USER_DELETE = 'broker_user:delete',
  BROKER_USER_READ = 'broker_user:read',
  BROKER_USER_RESTORE = 'broker_user:restore',
  BROKER_USER_UPDATE = 'broker_user:update',
  CADASTRAL_DATA_MATCHING_CREATE = 'cadastral-data-matching:create',
  BENEFICIARY_EXPORT = 'beneficiary:export',
  AUDIT_READ = 'audit:read',
  ASSET_IMAGE_CREATE = 'asset_image:create',
  ASSET_IMAGE_DELETE = 'asset_image:delete',
  ASSET_IMAGE_UPDATE = 'asset_image:update',
  COPAY_PROCEDURE_ADD_DESCRIPTION = 'copay_procedure:add_description',
  COPAY_PROCEDURE_ADD_LABEL = 'copay_procedure:add_label',
  COMPANY_HEALTH_DATA_MANAGE = 'company_health_data:manage',
  COMPANY_DIGITAL_HOSPITAL_MANAGE = 'company_digital_hospital:manage',
  CUSTOMIZIATIONS_APP = 'customizations:app',
}
